module.exports = __webpack_public_path__ + "static/media/shadow_JobFunction.9ad2c63b.svg";